import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="blue">Reiley Weekes </span>
            <br />
            I am currently employed as a Propulsion Engineer at ABL Space Systems.
            <br />
            I have a BS in Mechanical Engineering & an MS in Aerospace Engineering from UC San Diego. I was a few years into my PhD when I decided rejoin industry.
            <br />
            <br />
            Apart from building cool things, here are some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight/> Learning New Skills
            </li>
            <li className="about-activity">
              <ImPointRight/> Running
            </li>
            <li className="about-activity">
              <ImPointRight/> Video Games
            </li>
            <li className="about-activity">
              <ImPointRight/> Baking & Cooking
            </li>
            <li className="about-activity">
              <ImPointRight/> Trying New Foods
            </li>
          </ul>

          <p className="about-quote">
            "It's a beautiful day to build a <i className="about-quote-light">[insert anything to build here]</i> "{" "}
          </p>
          <footer className="blockquote-footer">R. Weekes</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
